import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/store';

import { RequestStatus } from 'constants/enums';

export const selectJobs = (state: RootState) => state.jobs.jobs;

export const selectActiveUserId = (state: RootState) =>
  state.sidebar.activeUserId;

export const selectActiveJob = createSelector(
  [selectJobs, selectActiveUserId],
  (jobs, activeJobId) => jobs.find((job) => job.id === activeJobId)
);

export const selectJobsDetails = (state: RootState) => {
  return state.jobs;
};

export const selectActiveJobDetails = (state: RootState) =>
  state.jobs.activeJobDetails;

export const selectIsLoading = (state: RootState) =>
  state.jobs.status === RequestStatus.Loading ||
  state.jobs.status === RequestStatus.Idle;

export const selectFreeJobsLeft = (state: RootState) => state.jobs.freeJobsLeft;

export const selectDashboardJobs = (state: RootState) =>
  state.jobs.dashboardJobs;
